import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col, Modal, Button } from 'react-bootstrap';

import AppContext from '../contexts/app-context';
import { ApiServiceServerless } from '../xhr_libs';
import OrganizationTypes from '../helpers/OrganizationTypes';
import AddressWrapper from '../helpers/AddressWrapper';
import AddEntityActionButtons from './forms/AddEntityActionButtons';
import { forceAuthRefresh } from '../xhr_libs';

const formStyle = {
  textAlign: 'left',
};

const orgDataDefaults = {
  name: '',
  report_name: '',
  address: {},
  organization_type: null,
};

function AddOrganization(props) {
  const {
    onHide,
    handleSetOrganization,
    setDefaultOrg,
    openBuildingModal,
    showToast,
    history,
  } = props;
  const { setToasts } = useContext(AppContext);

  const [organizationData, setOrganizationData] = useState(orgDataDefaults);
  const [validated, setValidated] = useState(false);
  const [validAddress, setValidAddress] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const navToNewOrg = (org_id) => {
    setToasts([]);
    history.push(`/organizations/${org_id}`);
  };

  const addNewOrgBuilding = (org) => {
    setToasts([]);
    setDefaultOrg(org);
    openBuildingModal();
  };

  const saveOrganization = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    let orgData = {
      name: organizationData.name,
      report_name: organizationData.report_name,
      address: organizationData.address,
      organization_type: organizationData.organization_type,
    };
    if (validAddress && form.checkValidity()) {
      setIsLoading(true);
      ApiServiceServerless.post(`/organizations`, orgData)
        .then((res) => {
          onHide();
          handleSetOrganization(res.data);
          setOrganizationData(orgDataDefaults);
          showToast(
            'success_button',
            'Success',
            <div>
              {'New organization ' +
                organizationData.name +
                ' was created and added to your organization '}
              <br></br>
              <Button
                variant='edit'
                onClick={() => addNewOrgBuilding(res.data)}
              >
                {'New Building'}
              </Button>
              <Button
                variant='edit'
                onClick={() => {
                  navToNewOrg(res.data.id);
                }}
              >
                {'View Organization Details'}
              </Button>
            </div>
          );
        })
        .catch(() => {
          showToast('danger', 'Error', 'Organization Creation Error');
        })
        .finally(() => {
          setValidated(false);
          setValidAddress(false);
          forceAuthRefresh();
          setIsLoading(false);
        });
    } else {
      setValidated(true);
    }
  };

  const handleCancel = () => {
    onHide();
    setValidated(false);
    setValidAddress(true);
    setOrganizationData(orgDataDefaults);
  };

  const saveDisabled = !organizationData.name || !validAddress;

  return (
    <Form
      noValidate
      validated={validated}
      onSubmit={saveOrganization}
      style={formStyle}
    >
      <Modal.Header closeButton>
        <div as='h5'>Create an Organization</div>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col sm={12}>
            <Form.Group controlId='newOrgForm.orgName'>
              <Form.Label>
                Name
                <span className='text-warning font-weight-bold pl-1'>*</span>
              </Form.Label>
              <Form.Control
                required
                placeholder=''
                onChange={(e) =>
                  setOrganizationData({
                    ...organizationData,
                    name: e.target.value,
                  })
                }
              />
            </Form.Group>

            <Form.Group controlId='newOrgForm.orgReportName'>
              <Form.Label>Name for Reports</Form.Label>
              <Form.Control
                placeholder=''
                onChange={(e) =>
                  setOrganizationData({
                    ...organizationData,
                    report_name: e.target.value,
                  })
                }
              />
            </Form.Group>

            <AddressWrapper
              address={organizationData.address}
              onAddressSelect={(value) =>
                setOrganizationData({
                  ...organizationData,
                  address: value,
                })
              }
              setValidAddress={setValidAddress}
            />
            <Form.Group controlId='newOrg.type'>
              <Form.Label>Organization type </Form.Label>
              <Form.Control
                as='select'
                onChange={(e) =>
                  setOrganizationData({
                    ...organizationData,
                    organization_type: e.target.value,
                  })
                }
                value={organizationData.organization_type || ''}
              >
                <option key={'select-type'} value={''}></option>
                {Object.keys(OrganizationTypes).map((data, index) => (
                  <option key={index} value={data}>
                    {OrganizationTypes[data]}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <AddEntityActionButtons
          onCancel={handleCancel}
          submitDisabled={saveDisabled || isLoading}
        />
      </Modal.Footer>
    </Form>
  );
}

AddOrganization.propTypes = {
  onHide: PropTypes.func,
  handleSetOrganization: PropTypes.func,
  showToast: PropTypes.func,
};

export default AddOrganization;
